// Google Analytics 4 helpers (gtag is loaded in index.html)
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const GA_MEASUREMENT_ID = "G-HPWJ0328CE";

function gtag(...args: unknown[]) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

export function trackPageView(path: string, title?: string) {
  gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title ?? document.title,
    send_to: GA_MEASUREMENT_ID,
  });
}

export interface GAItem {
  item_id: string;
  item_name: string;
  item_brand?: string;
  item_category?: string;
  item_variant?: string;
  price?: number;
  quantity?: number;
}

export function trackViewItem(item: GAItem, currency = "INR") {
  gtag("event", "view_item", {
    currency,
    value: item.price ?? 0,
    items: [item],
  });
}

export function trackAddToCart(item: GAItem, currency = "INR") {
  gtag("event", "add_to_cart", {
    currency,
    value: (item.price ?? 0) * (item.quantity ?? 1),
    items: [item],
  });
}

export function trackRemoveFromCart(item: GAItem, currency = "INR") {
  gtag("event", "remove_from_cart", {
    currency,
    value: (item.price ?? 0) * (item.quantity ?? 1),
    items: [item],
  });
}

export function trackBeginCheckout(items: GAItem[], value: number, currency = "INR") {
  gtag("event", "begin_checkout", { currency, value, items });
}

export function trackPurchase(params: {
  transaction_id: string;
  value: number;
  tax?: number;
  shipping?: number;
  coupon?: string;
  items: GAItem[];
  currency?: string;
}) {
  gtag("event", "purchase", {
    currency: params.currency ?? "INR",
    transaction_id: params.transaction_id,
    value: params.value,
    tax: params.tax,
    shipping: params.shipping,
    coupon: params.coupon,
    items: params.items,
  });
}

export function trackAddToWishlist(item: GAItem, currency = "INR") {
  gtag("event", "add_to_wishlist", {
    currency,
    value: item.price ?? 0,
    items: [item],
  });
}

export function trackSearch(search_term: string) {
  gtag("event", "search", { search_term });
}

export function trackSignUp(method = "email") {
  gtag("event", "sign_up", { method });
}

export function trackLogin(method = "email") {
  gtag("event", "login", { method });
}
